<template>
  <div class="esport-page-container">
    <div class="club-video-box">
      <div class="left-container" v-if="video">
        <div class="title-bar">
          <!-- <span class="video-type">
            <i
              class="icon icon-live-stream-red"
              :class="
                video.type === 'stream'
                  ? 'icon-live-stream-red'
                  : 'icon-video-red'
              "
            ></i
            >{{ getDict(video.type === "stream" ? 1 : 9) }}
          </span> -->
          <span class="video-title">{{ video.title }}</span>
          <span class="watch-num">
            <i class="icon icon-watch-people"></i
            >{{ video.viewCount | readableNum }}
          </span>
          <span class="user-info">
            <span
              v-if="video.streamerAvatar"
              class="user-avatar"
              :style="{
                backgroundImage: video.streamerAvatar
                  ? `url(${video.streamerAvatar})`
                  : 'none',
              }"
            ></span
            ><span class="user-name">{{ video.streamer }}</span>
            <!-- <i class="icon icon-follow" :class="[video.followed && 'active']"></i> -->
          </span>
          <span class="enter-live-stream" @click="goVideo(video.videoId)">{{
            getDict(6)
          }}</span>
        </div>
        <player
          class="video-player"
          :platform="video.platform"
          :video-id="video.videoId"
        />
      </div>
      <div class="video-list-switch-box">
        <div class="video-list-border">
          <div class="video-list">
            <div
              v-for="(v, index) in videoList"
              class="video-container"
              @click="activeVideoIndex = index"
              :key="index"
            >
              <div
                class="video-thumbnail-wrapper"
                :class="{ active: index === activeVideoIndex }"
                :style="{ backgroundImage: `url(${v.thumbnailMedium})` }"
              >
                <div class="video-info">
                  <div class="user-info">
                    <span
                      class="user-avatar"
                      :style="{
                        backgroundImage: v.streamerAvatar
                          ? `url(${v.streamerAvatar})`
                          : 'none',
                      }"
                    ></span
                    ><span class="user-name">{{ v.streamer }}</span>
                  </div>
                  <div class="watch-num">
                    <i class="icon icon-watch-people-yellow"></i
                    ><span>{{ v.viewCount | readableNum }}</span>
                  </div>
                </div>
              </div>
              <h3 class="video-title">{{ v.title }}</h3>
            </div>
          </div>
        </div>

        <div class="bottom-splint-box"></div>
      </div>
    </div>
    <clubNav />
  </div>
</template>

<script>
import { getDict, axios, formatDate, getPageLevelMixin, bus } from "@/common";
import { mapState, mapGetters } from "vuex";
import store from "@/store";
import AutoTitle from "@/components/autoTitle";
import preDiv from "@/components/preDiv";
import Player from "@/components/player";
import lrSlideBox from "../../comps/lr-slide-box";
import clubNav from "../../comps/clubNav";

export default {
  name: "eSportClubPage",
  // mixins: [getPageLevelMixin],
  components: {
    AutoTitle,
    preDiv,
    lrSlideBox,
    clubNav,
    Player,
  },
  props: {},
  data() {
    return {
      activeVideoIndex: 0,

      targetVideoId: "",
    };
  },
  computed: {
    ...mapGetters({
      curClub: "clubPage/curClub",
    }),
    videoList() {
      return (this.curClub ? this.curClub.videos : null) || [];
    },
    video() {
      if (this.videoList[this.activeVideoIndex]) {
        return {
          ...this.videoList[this.activeVideoIndex],
          type: ["live", "upComing", "upcoming"].includes(
            this.videoList[this.activeVideoIndex].liveBroadcastContent
          )
            ? "stream"
            : "video",
        };
      } else {
        return {};
      }
    },
  },
  watch: {
    video() {
      this.changeVideo(this.video, false);
    },
    curClub() {
      if (this.targetVideoId) {
        this.setVideoId(this.targetVideoId);
        this.targetVideoId = "";
      }
    },
  },
  methods: {
    getDict,
    goVideo(id) {
      this.$router.push(`/video/${id}`);
    },
    setVideoId(id) {
      this.targetVideoId = id;
      for (let i = 0; i < this.videoList.length; i++) {
        if (this.videoList[i].videoId == id) {
          this.activeVideoIndex = i;
          this.targetVideoId = "";
          break;
        }
      }
    },
    async changeVideo(video, leave) {
      if (video && video.videoId) {
        await webSocket.get("/live/watch", {
          room_id: video.videoId,
          leave,
          live: ["live", "upComing", "upcoming"].includes(
            video.liveBroadcastContent
          ),
        });
      }
    },
  },

  mounted() {},
  created() {
    store.dispatch("clubPage/getClubListWhileNeed");
    // this.changeVideo(this.video, false);
    bus.$once("setClubVideoId", (vid) => {
      this.setVideoId(vid);
    });
  },
  beforeDestroy() {
    this.changeVideo(this.video, true);
  },
};
</script>

  <style lang="scss" scoped>
.esport-page-container {
  height: 0;
  flex: 1;
  margin-top: 0.12rem;
  display: flex;

  .club-video-box {
    flex: 1;
    display: flex;
    margin-right: 0.15rem;

    .left-container {
      width: 7.3rem;
      margin-right: 0.1rem;
      /*display: flex;*/
      /*flex-direction: column;*/
    }
    $title-bar-height: 0.56rem;
    .title-bar {
      height: $title-bar-height;
      padding: 0 0.12rem;
      line-height: 0.36rem;
      background: rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      position: relative;
      .video-type {
        color: #c90e0e;
        font-size: 0.18rem;
        margin-right: 0.18rem;
      }
      .video-title {
        color: #232324;
        font-size: 0.22rem;
        max-width: 1.75rem;
        // max-width: 4.5rem;
        margin-right: 0.12rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .watch-num {
        color: white;
        font-size: 0.22rem;
        padding-right: 0.13rem;
        margin-right: 0.13rem;
        position: relative;
        &:after {
          content: " ";
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -0.115rem;
          width: 1px;
          height: 0.23rem;
          background: white;
        }
      }
      .user-info {
        color: white;
        font-size: 0.22rem;
        display: flex;
        align-items: center;
        .user-avatar {
          display: inline-block;
          background: no-repeat center center;
          background-size: 100% 100%;
          width: 0.38rem;
          height: 0.38rem;
          border-radius: 50%;
          margin-right: 0.04rem;
          border: 0.01rem solid #ecbc5f;
        }
        .user-name {
          max-width: 1.2rem;
          // max-width: 4rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      .enter-live-stream {
        height: 0.36rem;
        line-height: 0.36rem;
        padding: 0 0.17rem;
        font-size: 0.2rem;
        color: #232324;
        background: url(~@/assets/enter-live-stream-btn.png) no-repeat center
          center;
        background-size: 100% 100%;
        position: absolute;
        right: 0.12rem;
        top: 50%;
        margin-top: -0.18rem;
        .lang-jp & {
          font-size: 0.13rem;
        }
        .lang-en & {
          font-size: 0.15rem;
        }
      }
    }
    $video-player-height: 4.14rem;
    .video-player {
      height: $video-player-height;
    }
    .video-list-switch-box {
      width: 0;
      flex: 1;
      min-height: 0px;
      // width: 3.6rem;
      height: $title-bar-height + $video-player-height;
      display: flex;
      flex-direction: column;
      .video-list-border {
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        $border-radius: 0.04rem;
        border-radius: $border-radius;
        position: relative;
        padding: 0.1rem;
        background-color: rgba(#fff, 0.3);
        $border-weight: 0.02rem;
        $border-color: #fff;
        $color-start: 10%;
        $color-end: 30%;

        &::after,
        &::before {
          content: "";
          // z-index: 20;
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          border-radius: $border-radius;
        }
        $linear-deg: 50;
        &::before {
          border-left: $border-weight solid $border-color;
          border-bottom: $border-weight solid $border-color;
          mask: linear-gradient(
            #{$linear-deg * 1deg},
            #000 #{$color-start},
            transparent #{$color-end}
          );
        }
        &::after {
          border-top: $border-weight solid $border-color;
          border-right: $border-weight solid $border-color;
          mask: linear-gradient(
            #{($linear-deg + 180) * 1deg},
            #000 #{$color-start},
            transparent #{$color-end}
          );
        }
      }
      .video-list {
        position: relative;
        z-index: 1;
        height: 0;
        flex: 1;
        overflow: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: flex-start;

        .video-container {
          $video-width: 1.65rem;
          $video-height: $video-width * 9/16; //0.85rem;

          $video-title-height: 0.24rem;
          width: $video-width;
          height: $video-height + $video-title-height;

          margin-bottom: 0.13rem;
          &:last-child {
            margin-bottom: 0;
          }

          .video-thumbnail-wrapper {
            width: $video-width;
            height: $video-height;
            background: rgba(255, 255, 255, 0.4) no-repeat center center;
            background-size: cover;
            position: relative;
            border: none;

            $active-border-width: 0.03rem;
            &.active {
              &:after {
                content: " ";
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                border: #{$active-border-width} solid #ffd559;
                box-sizing: border-box;
              }
            }
            .video-info {
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              font-size: 0.12rem;
              height: 0.28rem + $active-border-width * 2;
              background: rgba(0, 0, 0, 0.7);
              color: #ffd559;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 0.1rem;

              .user-info {
                flex: 1;
                display: flex;
                .user-avatar {
                  $size: 0.2rem;
                  display: inline-block;
                  background: no-repeat center center;
                  background-size: 100% 100%;
                  width: $size;
                  height: $size;
                  border-radius: 50%;
                  margin-right: 0.04rem;
                  border: 0.01rem solid #ecbc5f;
                  vertical-align: -0.04rem;
                }
                .user-name {
                  width: 0;
                  flex: 1;
                  // max-width: 1.2rem;
                  display: inline-block;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                }
              }
              .watch-num {
                margin-left: 0.05rem;
                height: 2em;
                line-height: 2em;
                .icon {
                  $size: 1em;
                  width: $size;
                  height: $size;
                }
              }
            }
          }
          .video-title {
            color: #232324;
            font-size: 0.13rem;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            margin-top: 0.03rem;
            line-height: $video-title-height;
          }
        }
      }
    }
  }
}
.bottom-splint-box {
  $margin-bottom: 0.08rem;
  width: 100%;
  height: $margin-bottom;
  display: flex;
  align-items: flex-end;
  &::before {
    content: "";
    flex: 1;
    height: 0.04rem;
    border-bottom: 0.01rem solid rgba(#fff, 0.4);
    margin-right: 0.04rem;
  }
  &::after {
    content: "";
    width: 0.34rem;
    height: 0.04rem;
    background-image: url(../../imgs/box-bottom-splint.png);
    background-size: 100% 100%;
  }
}
</style>
